module.exports = __webpack_public_path__ + "img/index-fpsq.cb4d8429.png";